import { useNavigate } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';

export default function About() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-lp-bg">
      <Navbar />
      
      <div className="pt-20 px-4 pb-8">
        {/* Header */}
        <div className="mb-6">
          <button 
            onClick={() => navigate('/')}
            className="flex items-center gap-2 text-sepia-600 hover:text-sepia-800 font-ui text-sm mb-4 transition-colors duration-200"
          >
            <i className="ri-arrow-left-line"></i>
            Volver al inicio
          </button>
          
          <div className="vintage-paper aged-paper p-6 shadow-lg text-center">
            <h1 className="font-headings text-2xl text-sepia-900 mb-2">VINTAGE LITERAL</h1>
            <p className="text-sm text-sepia-600 font-ui">
              Una comunidad literaria con mirada retro
            </p>
          </div>
        </div>

        {/* Hero Image */}
        <div className="mb-6 overflow-hidden shadow-lg vintage-paper relative">
          <img 
            src="https://readdy.ai/api/search-image?query=vintage%20library%20interior%20with%20tall%20bookshelves%2C%20antique%20wooden%20ladders%2C%20leather-bound%20books%2C%20warm%20golden%20lighting%2C%20old%20reading%20tables%20with%20brass%20lamps%2C%20scholarly%20atmosphere%2C%20sepia%20tones%2C%20classic%20academic%20setting%2C%20nostalgic%20literary%20environment%2C%20aged%20paper%20and%20parchment%20textures%2C%20dusty%20sunbeams%20through%20windows&width=375&height=200&seq=about_hero&orientation=landscape"
            alt="Biblioteca vintage"
            className="w-full h-48 object-cover object-top"
          />
          {/* Overlay vintage sepia */}
          <div className="absolute inset-0 bg-sepia-800/25 mix-blend-multiply"></div>
          <div className="absolute inset-0 bg-gradient-to-b from-sepia-400/15 via-transparent to-sepia-700/20"></div>
        </div>

        {/* Mission */}
        <div className="vintage-paper aged-paper p-6 shadow-lg mb-6">
          <h2 className="font-headings text-lg text-sepia-900 mb-4 flex items-center gap-2">
            <i className="ri-heart-line text-sepia-600"></i>
            NUESTRA MISIÓN
          </h2>
          <p className="text-sm text-sepia-700 font-body leading-relaxed mb-4">
            Vintage Literal nace del amor por la literatura clásica y contemporánea, 
            ofreciendo un espacio donde la tradición literaria se encuentra con la 
            modernidad digital.
          </p>
          <p className="text-sm text-sepia-700 font-body leading-relaxed">
            Creemos que la literatura es un puente entre generaciones, y nuestra 
            plataforma permite a escritores, lectores y críticos compartir sus 
            perspectivas en un ambiente que respira nostalgia y elegancia.
          </p>
        </div>

        {/* Features */}
        <div className="vintage-paper aged-paper p-6 shadow-lg mb-6">
          <h2 className="font-headings text-lg text-sepia-900 mb-4 flex items-center gap-2">
            <i className="ri-star-line text-sepia-600"></i>
            QUÉ OFRECEMOS
          </h2>
          <div className="space-y-4">
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 bg-sepia-200/60 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                <i className="ri-book-open-line text-sepia-700 text-sm"></i>
              </div>
              <div>
                <h3 className="font-headings text-sm text-sepia-900 mb-1">Contenido Curado</h3>
                <p className="text-xs text-sepia-700 font-body">
                  Noticias literarias actuales y artículos de nuestra comunidad
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <div className="w-8 h-8 bg-sepia-200/60 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                <i className="ri-edit-line text-sepia-700 text-sm"></i>
              </div>
              <div>
                <h3 className="font-headings text-sm text-sepia-900 mb-1">Plataforma de Escritura</h3>
                <p className="text-xs text-sepia-700 font-body">
                  Espacio para que usuarios afiliados publiquen sus propios artículos
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <div className="w-8 h-8 bg-sepia-200/60 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                <i className="ri-group-line text-sepia-700 text-sm"></i>
              </div>
              <div>
                <h3 className="font-headings text-sm text-sepia-900 mb-1">Comunidad Literaria</h3>
                <p className="text-xs text-sepia-700 font-body">
                  Conecta con otros amantes de la literatura y comparte opiniones
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <div className="w-8 h-8 bg-sepia-200/60 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                <i className="ri-palette-line text-sepia-700 text-sm"></i>
              </div>
              <div>
                <h3 className="font-headings text-sm text-sepia-900 mb-1">Experiencia Vintage</h3>
                <p className="text-xs text-sepia-700 font-body">
                  Diseño nostálgico que evoca las bibliotecas y estudios clásicos
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Team */}
        <div className="vintage-paper aged-paper p-6 shadow-lg mb-6">
          <h2 className="font-headings text-lg text-sepia-900 mb-4 flex items-center gap-2">
            <i className="ri-team-line text-sepia-600"></i>
            NUESTRO EQUIPO
          </h2>
          <p className="text-sm text-sepia-700 font-body leading-relaxed mb-4">
            Somos un grupo de apasionados por la literatura, desde escritores establecidos 
            hasta jóvenes críticos, unidos por el amor a las letras y el deseo de 
            crear un espacio único en el mundo digital.
          </p>
          <div className="vintage-paper-subtle p-4 rounded-[10%]">
            <p className="text-xs text-sepia-600 font-ui italic text-center">
              "La literatura es el arte de descubrir algo extraordinario acerca de 
              la gente ordinaria, y decir con palabras ordinarias algo extraordinario."
            </p>
          </div>
        </div>

        {/* Contact */}
        <div className="vintage-paper aged-paper p-6 shadow-lg">
          <h2 className="font-headings text-lg text-sepia-900 mb-4 flex items-center gap-2">
            <i className="ri-mail-line text-sepia-600"></i>
            CONTÁCTANOS
          </h2>
          <p className="text-sm text-sepia-700 font-body leading-relaxed mb-4">
            ¿Tienes preguntas, sugerencias o te gustaría formar parte de nuestra 
            comunidad de usuarios afiliados? Nos encantaría escucharte.
          </p>
          <div className="grid grid-cols-1 gap-3">
            <button
              onClick={() => navigate('/contact')}
              className="vintage-paper-subtle text-sepia-900 hover:bg-sepia-200/70 px-4 py-3 text-sm font-ui transition-all duration-300 rounded-[15%] hover:shadow-md flex items-center justify-center gap-2"
            >
              <i className="ri-send-plane-line"></i>
              Enviar mensaje
            </button>
            <div className="text-center">
              <p className="text-xs text-sepia-600 font-ui">
                También puedes seguirnos en nuestras redes sociales
              </p>
              <div className="flex justify-center gap-4 mt-2">
                <button className="text-sepia-600 hover:text-sepia-800 transition-colors">
                  <i className="ri-twitter-line"></i>
                </button>
                <button className="text-sepia-600 hover:text-sepia-800 transition-colors">
                  <i className="ri-instagram-line"></i>
                </button>
                <button className="text-sepia-600 hover:text-sepia-800 transition-colors">
                  <i className="ri-facebook-line"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Vintage Background */}
        <div 
          className="fixed inset-0 pointer-events-none opacity-5 z-0"
          style={{
            backgroundImage: `url('https://readdy.ai/api/search-image?query=vintage%20about%20us%20scene%2C%20old%20parchment%20documents%2C%20antique%20quill%20pen%20and%20inkwell%2C%20aged%20manuscript%20pages%2C%20scholarly%20desk%20setup%2C%20warm%20sepia%20lighting%2C%20classic%20literature%20books%2C%20nostalgic%20academic%20atmosphere%2C%20brass%20reading%20lamp%2C%20weathered%20paper%20textures%2C%20brown%20and%20cream%20color%20palette&width=375&height=812&seq=about_bg&orientation=portrait')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            mixBlendMode: 'multiply'
          }}
        />
      </div>
    </div>
  );
}